import ModernAdminDashboard from "./ModernAdminDashboard";

const AdminDashboard = () => {
  return <ModernAdminDashboard />;
};

export default AdminDashboard;
